export default function (colleagues, availabilities) {
  return colleagues.map(({ id, email_address, name }) => {
    const phoneNumber = availabilities[id]?.internal_number.toString();
    const availability = availabilities[id]?.availability;

    return {
      colleagueUuid: id,
      emailAddress: email_address,
      description: name,
      phoneNumber,
      availability,
    };
  });
}
